<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog :title="$t('text.manualPayment')"
               :visible="isShowCreateTransferDialog"
               width="30%"
               top="4vh"
               :close-on-click-modal="false"
               @close="handleDialog">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item :label="$t('text.appId')"
                      label-width="120px"
                      prop="appId">
          <el-input size="small"
                    type="text"
                    v-model="form.appId"
                    :placeholder="$t('message.inputAppId')"/>
        </el-form-item>
        <el-form-item :label="$t('text.signKey')"
                      label-width="120px"
                      prop="signKey">
          <el-input size="small"
                    type="text"
                    v-model="form.signKey"
                    :placeholder="$t('message.inputSignKey')"/>
        </el-form-item>
        <el-form-item :label="$t('text.amountCent')"
                      label-width="120px"
                      prop="amount">
          <el-input size="small"
                    type="text"
                    v-model="form.amount"
                    :placeholder="$t('message.inputAmount')"/>
        </el-form-item>
        <el-form-item :label="$t('text.merchantOrderId')"
                      label-width="120px"
                      prop="merchantOrderId">
          <el-input size="small"
                    type="text"
                    v-model="form.merchantOrderId"
                    :placeholder="$t('message.inputMerchantOrderId')"/>
          <el-button type="primary"
                     size="mini"
                     plain
                     @click="genMerOrderId"
                     style="margin-left: 10px">
            {{ $t('text.generate') }}
          </el-button>
        </el-form-item>
        <el-form-item :label="$t('text.notifyUrl')"
                      label-width="120px"
                      prop="notifyUrl">
          <el-input size="small"
                    type="text"
                    v-model="form.notifyUrl"
                    :placeholder="$t('message.inputNotifyUrl')"/>
        </el-form-item>
        <el-form-item :label="$t('text.accountType')"
                      label-width="120px"
                      prop="accountType">
          <el-input size="small"
                    type="text"
                    v-model="form.accountType"
                    :placeholder="$t('message.inputAccountType')"/>
        </el-form-item>
        <el-form-item :label="$t('text.accountNumber')"
                      label-width="120px"
                      prop="accountNum">
          <el-input size="small"
                    type="text"
                    v-model="form.accountNum"
                    :placeholder="$t('message.inputAccountNum')"/>
        </el-form-item>
        <el-form-item :label="$t('text.customerName')"
                      label-width="120px"
                      prop="customerName">
          <el-input size="small"
                    type="text"
                    v-model="form.customerName"
                    :placeholder="$t('message.inputCustomerName')"/>
        </el-form-item>
        <el-form-item :label="$t('text.customerCert')"
                      label-width="120px"
                      prop="customerCert">
          <el-input size="small"
                    type="text"
                    v-model="form.customerCert"
                    :placeholder="$t('message.inputCustomerCert')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
let Base64 = require('js-base64').Base64;

export default {
  props: {
    isShowCreateTransferDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        appId: '',
        signKey: '',
        amount: '',
        merchantOrderId: '',
        notifyUrl: '',
        accountType: '',
        accountNum: '',
        customerName: '',
        customerCert: '',
      },
      rules: {},
    }
  },
  methods: {
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        appId: '',
        signKey: '',
        amount: '',
        merchantOrderId: '',
        notifyUrl: '',
        accountType: '',
        accountNum: '',
        customerName: '',
        customerCert: '',
      }
      this.$emit('update:isShowCreateTransferDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            ...this.form,
          }

          const base64Str = Base64.encode(params.appId + ':' + params.signKey);

          const url = '/open-api/pay/transfer'
          let testRequest = new Request(url, {
            method: 'post',
            headers: {
              'Content-Type': 'application/json;charset=utf-8;',
              Authorization: 'Basic ' + base64Str,
            },
            body: JSON.stringify(params),
          })
          fetch(testRequest).then(response => {
            let result = response.json()
            result.then(res => {
              console.log(res)
              if (res.code === 200 && res.status === '99') {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowCreateTransferDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                })
              }
            })
          })
        }
      })
    },

    genMerOrderId() {
      const uuid = 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 12) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8
            return v.toString(12)
          }
      );
      const genId = 'df' + uuid;
      this.form.merchantOrderId = genId;
      return genId;
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 0 solid #e4e7ed;
}

::v-deep .el-form-item {
  margin-bottom: 1px;
}

::v-deep .el-form-item .el-input {
  width: 330px;
}
</style>